import React from 'react';
import { useMatomo } from '@datapunt/matomo-tracker-react'
import { clsx } from 'clsx';

const ICON = `M30.75,27.69c2.63-2.7,4.25-6.38,4.25-10.45,0-8.28-6.72-15-15-15S5,8.96,5,17.24c0,4.06,1.62,7.74,4.25,10.45,.01,.01,
  9.57,9.58,9.57,9.58,.65,.65,1.71,.65,2.36,0,0,0,9.56-9.57,9.57-9.58Z`;

const size = 38;

const pinStyle = {
  cursor: 'pointer',
  fill: 'rgb(106,26,237)',
  stroke: 'none',
  width: size + 'px',
  height: size + 'px',
};

function RundedrehenMapPin({ item, activeItems, setActive }) {
  const { trackEvent } = useMatomo();

  return (
    <div
      className={
        clsx('transition-all opacity-60', {
          '!opacity-100 map-pin-active': (item.properties.ids.filter(value => activeItems.includes(value)).length),
          // '!opacity-100 map-pin-active': (item.properties.ids.includes(activeItem)),
          // '!opacity-100 map-pin-active': (activeItem == item.properties.id),
          // 'opacity-40': (activeItem != 0 && activeItem != item.properties.id),
        })
      }

      onMouseEnter={() => setActive(item.properties.ids)}
      onMouseLeave={() => setActive([])}
      onClick={(e) => {
        trackEvent({ category: 'map', action: 'click pin', name: item.properties.type + ' ' + item.properties.category + ' ' + item.properties.label });
      }}
    >
      <svg height={size} viewBox="0 0 40 40" style={pinStyle}>
        <path d={ICON} />
      </svg>
    </div>
  );
}

export default React.memo(RundedrehenMapPin);
